module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/placeholder/placeholder-03-ea5e1a9f0af9d141521f6688c78a27ba.jpg";